import { Toast } from "primereact/toast"
import { useRef, useState } from "react"
import { Form } from "./Form"
import { Table } from "./Table"

export interface IEscalations {
    id?: string,
    type_ID?: number,
    type_Name?: string,
    status_ID?: number,
    status?: string,
    comment?: string,
    created_By?: string,
    created_At?: Date,
    updated_By?: string,
    updated_At?: Date,
    canEdit?: boolean,
    consultant_ID?: string,
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
}

export interface IModel {
    open: boolean,
    singleData: any
}

export interface IProps {
    poID?: number | null,
}

export const EscalationMaster = (props: IProps) => {
    const [reLoad, setReLoad] = useState(false);
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModel);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false });
    }

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} setReLoad={() => setReLoad(!reLoad)} poID={props.poID} />
            <Table setModal={setModal} toast={toast} reLoad={reLoad} poID={props.poID} />
            <Toast ref={toast} />
        </>
    );
}